import type {
  BoggleResolvedChallengeConflict,
  BoggleResolvedChallengeMod,
} from '~/boggle/config/challenges/modTypes'

export function getBoggleResolvedChallengeConflict(
  first: BoggleResolvedChallengeMod,
  second: BoggleResolvedChallengeMod,
): BoggleResolvedChallengeConflict | null {
  for (const firstOutcome of first.outcomes) {
    for (const secondOutcome of second.outcomes) {
      if (
        firstOutcome.kind === 'requires-adjacent-path' &&
        secondOutcome.kind === 'requires-non-adjacent-path'
      ) {
        return {
          code: 'path-adjacency-mismatch',
        }
      }

      if (
        firstOutcome.kind === 'requires-non-adjacent-path' &&
        secondOutcome.kind === 'requires-adjacent-path'
      ) {
        return {
          code: 'path-adjacency-mismatch',
        }
      }

      if (
        firstOutcome.kind === 'blocked-letter' &&
        secondOutcome.kind === 'vowel-replacement' &&
        firstOutcome.letter === secondOutcome.letter
      ) {
        return {
          code: 'replacement-letter-blocked',
          letter: firstOutcome.letter,
        }
      }

      if (
        firstOutcome.kind === 'vowel-replacement' &&
        secondOutcome.kind === 'blocked-letter' &&
        firstOutcome.letter === secondOutcome.letter
      ) {
        return {
          code: 'replacement-letter-blocked',
          letter: firstOutcome.letter,
        }
      }
    }
  }

  return null
}

export function areBoggleResolvedChallengeModsCompatible(
  first: BoggleResolvedChallengeMod,
  second: BoggleResolvedChallengeMod,
) {
  return getBoggleResolvedChallengeConflict(first, second) === null
}
